import Pusher from 'pusher-js';
import { useEffect, useRef } from 'react';
import { useSetRecoilState } from 'recoil';
import { environment } from '../../environments/environment';
import { eventReloadState } from '../../storage/gptStates';

function PusherSafeGptProvider() {
  const setUpdateControlTowerEvents = useSetRecoilState(eventReloadState);
  const pusherRef = useRef<Pusher | null>(null);

  useEffect(() => {
    if (!pusherRef.current) {
      pusherRef.current = new Pusher(environment.pusherKey ?? '', {
        cluster: environment.pusherCluster,
      });
    }

    return () => {
      pusherRef.current?.disconnect();
      pusherRef.current = null;
    };
  }, []);

  useEffect(() => {
    const pusher = pusherRef.current;
    if (!pusher) return;
    const channelSafeGpt = pusher.subscribe('safeGPT');

    channelSafeGpt.bind('newEvent', (data: { eventId: string }) => {
      if (data.eventId) {
        setUpdateControlTowerEvents('update');
      }
    });

    channelSafeGpt.bind('attendedEvent', (data: { eventId: string }) => {
      if (data.eventId) {
        setUpdateControlTowerEvents('update');
      }
    });

    channelSafeGpt.bind('expiredEvent', (data: { eventId: string }) => {
      if (data.eventId) {
        setUpdateControlTowerEvents('update');
      }
    });

    return () => {
      pusher.unbind_all();
    };
  }, []);

  return null;
}

export default PusherSafeGptProvider;
